export const types = {

    GET_LOGIN_SUCCESS : 'GET_LOGIN_SUCCESS',
    GET_LOGIN_FAILED: 'GET_LOGIN_FAILED',

    GET_SIGNUP_SUCCESS: 'GET_SIGNUP_SUCCESS',
    GET_SIGNUP_FAILED: 'GET_SIGNUP_FAILED',

    CHECK_AUTH_SUCCESS: 'CHECK_AUTH_SUCCESS',
    CHECK_AUTH_FAILED: 'CHECK_AUTH_FAILED',



    CREATE_CUSTOMER_SUCCESS : 'CREATE_CUSTOMER_SUCCESS',
    CREATE_CUSTOMER_FAILED : 'CREATE_CUSTOMER_FAILED',

    GET_CUSTOMER_SUCCESS : 'GET_CUSTOMER_SUCCESS',
    GET_CUSTOMER_FAILED : 'GET_CUSTOMER_FAILED',

    GET_ALL_CUSTOMER_SUCCESS : 'GET_ALL_CUSTOMER_SUCCESS',
    GET_ALL_CUSTOMER_FAILED : 'GET_ALL_CUSTOMER_FAILED',

    UPDATE_CUSTOMER_SUCCESS : 'UPDATE_CUSTOMER_SUCCESS',
    UPDATE_CUSTOMER_FAILED : 'UPDATE_CUSTOMER_FAILED',
    UPDATE_CUSTOMER_REQUEST : 'UPDATE_CUSTOMER_REQUEST',

    DELETE_CUSTOMER_SUCCESS : 'DELETE_CUSTOMER_SUCCESS',
    DELETE_CUSTOMER_FAILED : 'DELETE_CUSTOMER_FAILED',

    CHANGE_PASSWORD_SUCCESS : 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILED : 'CHANGE_PASSWORD_FAILED',

    GET_ACCOUNT_PROFILE_SUCCESS : 'GET_ACCOUNT_PROFILE_SUCCESS',
    GET_ACCOUNT_PROFILE_FAILED: 'GET_ACCOUNT_PROFILE_FAILED',

    UPDATE_ACCOUNT_PROFILE_SUCCESS : 'UPDATE_ACCOUNT_PROFILE_SUCCESS',
    UPDATE_ACCOUNT_PROFILE_FAILED: 'UPDATE_ACCOUNT_PROFILE_FAILED',

    GET_PROFILE_WITH_USER_SUCCESS : 'GET_PROFILE_WITH_USER_SUCCESS',
    GET_PROFILE_WITH_USER_FAILED: 'GET_PROFILE_WITH_USER_FAILED',


    CREATE_SUBSCRIPTION_PLAN_SUCCESS : 'CREATE_SUBSCRIPTION_PLAN_SUCCESS',
    CREATE_SUBSCRIPTION_PLAN_FAILED : 'CREATE_SUBSCRIPTION_PLAN_FAILED',

    GET_SUBSCRIPTION_PLAN_SUCCESS : 'GET_SUBSCRIPTION_PLAN_SUCCESS',
    GET_SUBSCRIPTION_PLAN_FAILED : 'GET_SUBSCRIPTION_PLAN_FAILED',

    GET_ALL_SUBSCRIPTION_PLAN_SUCCESS : 'GET_ALL_SUBSCRIPTION_PLAN_SUCCESS',
    GET_ALL_SUBSCRIPTION_PLAN_FAILED : 'GET_ALL_SUBSCRIPTION_PLAN_FAILED',

    UPDATE_SUBSCRIPTION_PLAN_SUCCESS : 'UPDATE_SUBSCRIPTION_PLAN_SUCCESS',
    UPDATE_SUBSCRIPTION_PLAN_FAILED : 'UPDATE_SUBSCRIPTION_PLAN_FAILED',

    DELETE_SUBSCRIPTION_PLAN_SUCCESS : 'DELETE_SUBSCRIPTION_PLAN_SUCCESS',
    DELETE_SUBSCRIPTION_PLAN_FAILED : 'DELETE_SUBSCRIPTION_PLAN_FAILED',
    


    CREATE_USER_SUBSCRIPTION_SUCCESS : 'CREATE_USER_SUBSCRIPTION_SUCCESS',
    CREATE_USER_SUBSCRIPTION_FAILED : 'CREATE_USER_SUBSCRIPTION_FAILED',

    GET_USER_SUBSCRIPTION_SUCCESS : 'GET_USER_SUBSCRIPTION_SUCCESS',
    GET_USER_SUBSCRIPTION_FAILED : 'GET_USER_SUBSCRIPTION_FAILED',

    GET_ALL_USER_SUBSCRIPTION_SUCCESS : 'GET_ALL_USER_SUBSCRIPTION_SUCCESS',
    GET_ALL_USER_SUBSCRIPTION_FAILED : 'GET_ALL_USER_SUBSCRIPTION_FAILED',

    GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS: 'GET_USER_SUBSCRIPTIONS_By_PLAN_ID_SUCCESS',
    GET_USER_SUBSCRIPTIONS_By_PLAN_ID_FAILED: 'GET_USER_SUBSCRIPTIONS_By_PLAN_ID_FAILED',

    GET_USER_SUBSCRIPTIONS_By_USER_ID_SUCCESS: 'GET_USER_SUBSCRIPTIONS_By_USER_ID_SUCCESS',
    GET_USER_SUBSCRIPTIONS_By_USER_ID_FAILED: 'GET_USER_SUBSCRIPTIONS_By_USER_ID_FAILED',

    UPDATE_USER_SUBSCRIPTION_SUCCESS : 'UPDATE_USER_SUBSCRIPTION_SUCCESS',
    UPDATE_USER_SUBSCRIPTION_FAILED : 'UPDATE_USER_SUBSCRIPTION_FAILED',

    DELETE_USER_SUBSCRIPTION_SUCCESS : 'DELETE_USER_SUBSCRIPTION_SUCCESS',
    DELETE_USER_SUBSCRIPTION_FAILED : 'DELETE_USER_SUBSCRIPTION_FAILED',

    

    CREATE_TRANSACTION_SUCCESS : 'CREATE_TRANSACTION_SUCCESS',
    CREATE_TRANSACTION_FAILED : 'CREATE_TRANSACTION_FAILED',

    GET_ALL_TRANSACTION_SUCCESS : 'GET_ALL_TRANSACTION_SUCCESS',
    GET_ALL_TRANSACTION_FAILED : 'GET_ALL_TRANSACTION_FAILED',

    GET_TRANSACTION_SUCCESS : 'GET_TRANSACTION_SUCCESS',
    GET_TRANSACTION_FAILED : 'GET_TRANSACTION_FAILED',

    GET_TRANSACTIONS_BY_USER_ID_SUCCESS : 'GET_TRANSACTIONS_BY_USER_ID_SUCCESS',
    GET_TRANSACTIONS_BY_USER_ID_FAILED : 'GET_TRANSACTIONS_BY_USER_ID_FAILED',

    CREATE_PAYMENT_SUCCESS : 'CREATE_PAYMENT_SUCCESS',
    CREATE_PAYMENT_FAILED : 'CREATE_PAYMENT_FAILED',

    GET_PAYMENT_SUCCESS : 'GET_PAYMENT_SUCCESS',
    GET_PAYMENT_FAILED : 'GET_PAYMENT_FAILED',

    GET_ALL_PAYMENT_SUCCESS : 'GET_ALL_PAYMENT_SUCCESS',
    GET_ALL_PAYMENT_FAILED : 'GET_ALL_PAYMENT_FAILED',

    UPDATE_PAYMENT_SUCCESS : 'UPDATE_PAYMENT_SUCCESS',
    UPDATE_PAYMENT_FAILED : 'UPDATE_PAYMENT_FAILED',

    DELETE_PAYMENT_SUCCESS : 'DELETE_PAYMENT_SUCCESS',
    DELETE_PAYMENT_FAILED : 'DELETE_PAYMENT_FAILED',




    GET_PAYMENT_SETTING_SUCCESS: 'GET_PAYMENT_SETTING_SUCCESS',
    GET_PAYMENT_SETTING_FAILED: 'GET_PAYMENT_SETTING_FAILED',

    GET_ALL_PAYMENT_SETTINGS_SUCCESS: 'GET_ALL_PAYMENT_SETTINGS_SUCCESS',
    GET_ALL_PAYMENT_SETTINGS_FAILED: 'GET_ALL_PAYMENT_SETTINGS_FAILED',

    UPDATE_PAYMENT_SETTING_SUCCESS: 'UPDATE_PAYMENT_SETTING_SUCCESS',
    UPDATE_PAYMENT_SETTING_FAILED: 'UPDATE_PAYMENT_SETTING_FAILED',

    DELETE_PAYMENT_SETTING_SUCCESS: 'DELETE_PAYMENT_SETTING_SUCCESS',
    DELETE_PAYMENT_SETTING_FAILED: 'DELETE_PAYMENT_SETTING_FAILED',

    RESET_SUCCESS_ALERT: 'RESET_SUCCESS_ALERT',
    GET_PROFILE_WITH_USER_NOT_FOUND: 'GET_PROFILE_WITH_USER_NOT_FOUND',

    UPDATE_WHATSAPP_SETTINGS_SUCCESS: 'UPDATE_WHATSAPP_SETTINGS_SUCCESS',
    UPDATE_WHATSAPP_SETTINGS_FAILED: 'UPDATE_WHATSAPP_SETTINGS_FAILED',

    GET_WHATSAPP_SETTINGS_SUCCESS: 'GET_WHATSAPP_SETTINGS_SUCCESS',
    GET_WHATSAPP_SETTINGS_FAILED: 'GET_WHATSAPP_SETTINGS_FAILED',


    CREATE_PAYMENT_REQUEST_DATA_SUCCESS: 'CREATE_PAYMENT_REQUEST_DATA_SUCCESS',
    CREATE_PAYMENT_REQUEST_DATA_FAILED: 'CREATE_PAYMENT_REQUEST_DATA_FAILED',

    SEND_WHATSAPP_PAYMENT_LINK_SUCCESS: 'SEND_WHATSAPP_PAYMENT_LINK_SUCCESS',
    SEND_WHATSAPP_PAYMENT_LINK_FAILED: 'SEND_WHATSAPP_PAYMENT_LINK_FAILED',
}